module.exports = __webpack_public_path__ + "static/media/icon-js.475d681b.svg";